function getStage(streak) {
  if (streak === 0) return 'seed'
  if (streak < 7) return 'sprout'
  if (streak < 30) return 'plant'
  if (streak < 90) return 'flowering'
  return 'tree'
}

const STAGE_LABELS = {
  seed: 'Plant a seed',
  sprout: 'Sprouting',
  plant: 'Growing strong',
  flowering: 'In bloom',
  tree: 'Mighty tree',
}

function Soil() {
  return (
    <>
      <ellipse cx="100" cy="180" rx="82" ry="18" fill="#2d1508" />
      <ellipse cx="100" cy="174" rx="65" ry="11" fill="#3e1e0c" opacity="0.9" />
    </>
  )
}

function SeedSVG() {
  return (
    <svg viewBox="0 0 200 200" width="100%" style={{ display: 'block', maxHeight: 140 }}>
      <Soil />
      <ellipse cx="100" cy="163" rx="14" ry="9" fill="#7a4a26" transform="rotate(-8 100 163)" />
      <ellipse cx="96" cy="159" rx="5" ry="3.5" fill="#a06030" opacity="0.65" />
      <path d="M100 157 Q103 153 100 160" stroke="#5a3010" strokeWidth="1.5" fill="none" opacity="0.8" />
    </svg>
  )
}

function SproutSVG() {
  return (
    <svg viewBox="0 0 200 200" width="100%" style={{ display: 'block', maxHeight: 140 }}>
      <Soil />
      <path d="M100 172 Q99 150 100 120" stroke="#22c55e" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M100 148 Q82 136 86 124 Q97 136 100 148Z" fill="#4ade80" />
      <path d="M100 143 Q118 131 114 119 Q103 131 100 143Z" fill="#22c55e" />
      <ellipse cx="100" cy="117" rx="4" ry="5.5" fill="#86efac" />
    </svg>
  )
}

function SmallPlantSVG() {
  return (
    <svg viewBox="0 0 200 200" width="100%" style={{ display: 'block', maxHeight: 140 }}>
      <Soil />
      <path d="M100 172 Q97 132 100 68" stroke="#16a34a" strokeWidth="4" fill="none" strokeLinecap="round" />
      <path d="M100 154 Q70 142 68 127 Q88 135 100 154Z" fill="#4ade80" />
      <path d="M100 149 Q130 137 132 122 Q112 130 100 149Z" fill="#22c55e" />
      <path d="M100 124 Q74 111 76 97 Q93 106 100 124Z" fill="#4ade80" />
      <path d="M100 119 Q126 106 124 92 Q107 101 100 119Z" fill="#22c55e" />
      <path d="M100 94 Q80 82 84 70 Q96 80 100 94Z" fill="#4ade80" />
      <path d="M100 90 Q120 78 116 66 Q104 76 100 90Z" fill="#22c55e" />
      <ellipse cx="100" cy="65" rx="5" ry="7" fill="#86efac" opacity="0.9" />
    </svg>
  )
}

function FloweringPlantSVG() {
  return (
    <svg viewBox="0 0 200 200" width="100%" style={{ display: 'block', maxHeight: 140 }}>
      <Soil />
      <path d="M100 172 Q96 130 100 42" stroke="#15803d" strokeWidth="4" fill="none" strokeLinecap="round" />
      <path d="M100 105 Q84 90 76 74" stroke="#16a34a" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M100 95 Q116 80 124 64" stroke="#16a34a" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <path d="M100 152 Q68 139 66 123 Q88 132 100 152Z" fill="#4ade80" />
      <path d="M100 147 Q132 134 134 118 Q112 127 100 147Z" fill="#22c55e" />
      <path d="M100 124 Q72 110 74 95 Q92 105 100 124Z" fill="#4ade80" />
      <path d="M100 118 Q128 104 126 89 Q108 99 100 118Z" fill="#22c55e" />
      {/* left flower */}
      <circle cx="68" cy="66" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="84" cy="66" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="76" cy="58" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="76" cy="74" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="76" cy="66" r="6" fill="#8b5cf6" opacity="0.8" />
      <circle cx="76" cy="66" r="4" fill="#fef9c3" />
      {/* right flower */}
      <circle cx="116" cy="56" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="132" cy="56" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="124" cy="48" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="124" cy="64" r="7" fill="#a78bfa" opacity="0.85" />
      <circle cx="124" cy="56" r="6" fill="#8b5cf6" opacity="0.8" />
      <circle cx="124" cy="56" r="4" fill="#fef9c3" />
      {/* top bud */}
      <ellipse cx="100" cy="38" rx="8" ry="11" fill="#7c3aed" />
      <ellipse cx="100" cy="34" rx="5" ry="7" fill="#a78bfa" />
      <circle cx="100" cy="31" r="3" fill="#c4b5fd" />
    </svg>
  )
}

function TreeSVG() {
  return (
    <svg viewBox="0 0 200 200" width="100%" style={{ display: 'block', maxHeight: 140 }}>
      <Soil />
      {/* roots */}
      <path d="M95 172 Q82 178 70 183" stroke="#5c3010" strokeWidth="3" fill="none" opacity="0.5" />
      <path d="M105 172 Q118 178 130 183" stroke="#5c3010" strokeWidth="3" fill="none" opacity="0.5" />
      {/* trunk */}
      <path d="M93 172 Q90 145 92 110" stroke="#7c4a1e" strokeWidth="14" fill="none" strokeLinecap="round" />
      <path d="M107 172 Q110 145 108 110" stroke="#5c3010" strokeWidth="9" fill="none" strokeLinecap="round" opacity="0.45" />
      {/* branches */}
      <path d="M96 122 Q78 108 66 90" stroke="#6b3e14" strokeWidth="7" fill="none" strokeLinecap="round" />
      <path d="M104 116 Q122 102 134 84" stroke="#6b3e14" strokeWidth="7" fill="none" strokeLinecap="round" />
      <path d="M100 108 Q97 90 98 74" stroke="#6b3e14" strokeWidth="6" fill="none" strokeLinecap="round" />
      {/* outer canopy */}
      <circle cx="100" cy="84" r="48" fill="#15803d" opacity="0.8" />
      <circle cx="68" cy="92" r="30" fill="#166534" opacity="0.85" />
      <circle cx="132" cy="88" r="28" fill="#166534" opacity="0.85" />
      {/* inner canopy */}
      <circle cx="90" cy="70" r="30" fill="#16a34a" opacity="0.9" />
      <circle cx="112" cy="74" r="28" fill="#16a34a" opacity="0.9" />
      <circle cx="100" cy="60" r="26" fill="#22c55e" opacity="0.85" />
      {/* highlights */}
      <circle cx="88" cy="62" r="14" fill="#4ade80" opacity="0.55" />
      <circle cx="110" cy="66" r="10" fill="#4ade80" opacity="0.45" />
      {/* purple flower accents */}
      <circle cx="76" cy="80" r="6" fill="#a78bfa" opacity="0.85" />
      <circle cx="76" cy="80" r="3" fill="#e9d5ff" opacity="0.9" />
      <circle cx="124" cy="76" r="6" fill="#a78bfa" opacity="0.85" />
      <circle cx="124" cy="76" r="3" fill="#e9d5ff" opacity="0.9" />
      <circle cx="98" cy="54" r="5" fill="#a78bfa" opacity="0.8" />
      <circle cx="98" cy="54" r="2.5" fill="#e9d5ff" opacity="0.9" />
      <circle cx="86" cy="86" r="5" fill="#c4b5fd" opacity="0.75" />
      <circle cx="114" cy="90" r="5" fill="#c4b5fd" opacity="0.75" />
    </svg>
  )
}

export default function PlantVisual({ streak, wilting }) {
  const stage = getStage(streak)

  return (
    <div style={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingBottom: 4,
      transformOrigin: 'bottom center',
      // Only transition INTO the wilted state — snapping back to seed is instant
      transition: wilting
        ? 'transform 1.4s ease-in-out, filter 1.4s ease-in-out, opacity 1.4s ease-in-out'
        : 'none',
      transform: wilting ? 'rotate(22deg) scaleY(0.65) translateX(14px)' : 'rotate(0deg) scaleY(1) translateX(0px)',
      filter: wilting ? 'saturate(0) brightness(0.2)' : 'none',
      opacity: wilting ? 0.25 : 1,
    }}>
      {stage === 'seed' && <SeedSVG />}
      {stage === 'sprout' && <SproutSVG />}
      {stage === 'plant' && <SmallPlantSVG />}
      {stage === 'flowering' && <FloweringPlantSVG />}
      {stage === 'tree' && <TreeSVG />}
      <p style={{
        color: 'rgba(167,139,250,0.45)',
        fontSize: 10,
        margin: '4px 0 0',
        letterSpacing: 1.5,
        textTransform: 'uppercase',
      }}>
        {STAGE_LABELS[stage]}
      </p>
    </div>
  )
}
